import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;

export const Div = styled.div`
  ${(props) =>
    props.theme.isDarkTheme &&
    `color: ${
      props.theme.isDarkTheme
        ? Color.textColorBlackSeven
        : Color.textColorBlackFor
    };`}
`;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const ItemValue = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackOne};
`;

export const SwipeRight = styled.div`
  background-color: ${Color.colorRed};
  color: ${Color.colorWhite};
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 6px;
  justify-content: flex-end;
`;

export const SwipeLeft = styled.div`
  background-color: ${Color.colorWarning};
  color: ${Color.colorWhite};
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 6px;
`;
